<template>
  <div class="nav-container">
    <div>
      <figure>
        <img
          class="logo"
          :src="getImage('logo.png')"
          alt="Rural Municipality Logo"
        />
      </figure>
    </div>
    <div>
      <p>
        <router-link :to="'/admin/homepage'" tag="a">
          <span class="ml-1 mr-1"><i class="fas fa-home"></i></span>
          <span>Home Page</span>
        </router-link>
      </p>
    </div>
    <div v-for="(link, i) in links" :key="link.target + '-' + i">
      <template
        v-if="
          link.name !== 'photos' || link.name !== 'pages' || link.name !== ''
        "
      >
        <p>
          <router-link :to="'/admin/dashboard/' + link.name" tag="a">
            <span class="ml-1 mr-1"><i :class="icons(link.name)"></i></span>
            <span>{{ link.display | capitalize }}</span>
          </router-link>
        </p>
      </template>
    </div>
    <div>
      <p>
        <router-link :to="'/admin/settings'" tag="a">
          <span class="ml-1 mr-1"><i class="fas fa-cog"></i></span>
          <span>Settings</span>
        </router-link>
      </p>
    </div>
    <div>
      <p class="has-text-centered mt-1 mb-1">
        <button @click="signOut" class="button is-info">Log Out</button>
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Navigation",
  data() {
    return {
      linkSet: [],
    };
  },
  created() {
    this.$store.dispatch("getNavigationLinks");
  },
  methods: {
    icons(value) {
      let string = "fas ";
      const icons = {
        agm: "fa-file-pdf",
        businesses: "fa-briefcase",
        bylaws: "fa-gavel",
        councillors: "fa-users",
        events: "fa-calendar-alt",
        galleries: "fa-images",
        photos: "fa-image",
        news: "fa-newspaper",
        subscribers: "fa-rss-square",
        pages: "fa-file",
        services: "fa-clipboard-list",
      };
      return string + icons[value];
    },
    getImage(img) {
      return process.env.VUE_APP_SERVER + "uploads/" + img;
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch("updateUserState", null);
          this.$router.replace({
            name: "Login",
          });
        });
    },
  },
  filters: {
    capitalize(value) {
      if (value) return value[0].toUpperCase() + value.substring(1);
    },
  },
  computed: {
    links() {
      const links = this.$store.getters["navigation"];
      return links ? links : this.linkSet;
    },
  },
};
</script>
